import { useLocation, Navigate } from "react-router-dom";
import React from 'react';
import { useAuthStore } from '../store/authStore';

const MyRequireAuth = ({ children, loginPath, allowedRoles }) => {
    const { roles, isAuthenticated } = useAuthStore();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    const userRoles = Array.isArray(roles) ? roles : [];

    // Rola NO_PERMISSIONS (lub brak jakiejkolwiek roli) nie ma dostępu do żadnej chronionej trasy
    if (userRoles.length === 0 || userRoles.includes('NO_PERMISSIONS')) {
        return <Navigate to="/Unauthorized" state={{ from: location }} replace />;
    }

    // Jeśli allowedRoles nie jest podane lub jest puste, dostęp ma każdy aktywny zalogowany użytkownik
    if (!allowedRoles || allowedRoles.length === 0) {
        return <>{children}</>;
    }

    const userHasAllowedRole = userRoles.some(r => allowedRoles.includes(r));
    if (!userHasAllowedRole) {
        return <Navigate to="/Unauthorized" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default MyRequireAuth;
